<template>
  <header>
    <nav class="topNav">
      <Ubutton size="xsmall" icon="134" iconSize="xsmall" state="deactive" @click.native="$store.commit('left')"/>
      <router-link :to="{ name: 'main', params: {} }" class="logoBtn">
        <icon class="logo" size="xsmall" uicon="160" state="active"/>
        <span>스담</span>
      </router-link>
      <UInput id="search" type="text" placeholder="검색" v-model="search" @focus="searchFocus" @enter="$router.push({name: 'search', params: {type: 'all', text: search}})">
        <template #last>
          <Ubutton size="xsmall" icon="117" iconSize="xsmall" state="deactive" @click.native="$router.push({name: 'search', params: {type: 'all', text: search}})"/>
        </template>
        <div v-if="layer" id="searchLayer">
          <div v-if="userList.length > 0" class="user">
            <span>유저</span>
            <li v-for="(user, index) in userList" :key="index" @click="$router.push({name: 'workprofile', params: {user: user._id}})">
              <Profile class="img" size="small" :src="user.profile"/>
              <span>{{ user.nic }}</span>
            </li>
          </div>
          <div v-if="workList.length > 0" class="work">
            <span>저작공간</span>
            <li v-for="(work, index) in workList" :key="index" @click="$router.push({name: 'workinfo', params: {work: work._id}})">
              <icon size="small" icon="createPost" title="글쓰기"/>
              <span>{{ work.name }}</span>
            </li>
          </div>
          <div v-if="bookList.length > 0" class="searchbook">
            <span>책</span>
            <li v-for="(book, index) in bookList" :key="index" @click="$router.push({name: 'bookinfo', params: {type: 'info', book: book._id}})">
              <div v-if="book.onepost.cover" class="cover">
                <img :src="book.onepost.cover" />
              </div>
              <div v-else class="not cover">
                +
              </div>
              <div>
                <span>{{ book.title }}</span>
                <span>{{ book.onepost.subtitle }}</span>
                <span>{{ book.nic }}</span>
              </div>
            </li>
          </div>
        </div>
      </UInput>
      <ul v-if="isLogin === true" class="topRightNav">
        <li class="alarm">
          <span v-if="$store.getters.isalarm" class="isnew"></span>
          <Ubutton size="small" icon="156" iconSize="small" state="deactive" title="알람" @click.native="openAlarm()"/>
        </li>
        <li>
          <Ubutton size="small" icon="113" iconSize="small" state="deactive" title="글쓰기" @click.native="goLink('edit')"/>
        </li>
        <li class="profileArea">
          <Profile class="img cursorButton" size="small" :src="getProfile" @click.native="profileOpen" title="내정보"/>
        </li>
      </ul>
      <ul v-else class="topRightNav">
        <li>
          <router-link :to="{name: 'login'}">로그인</router-link>
        </li>
      </ul>
    </nav>
    <div id="myCard" v-show="infoView">
      <div class="myCardInfo">
        <div class="myCardUserImg">
          <router-link class="bigProfile" :to="{ name: 'profile', params: {} }">
            <Profile class="img" size="big" :src="getProfile"/>
          </router-link>
        </div>
        <div>
          <ul class="myCardInfoList">
            <li id="myCardNic">{{ getNic }}</li>
            <li id="myCardEmail">
              <span>{{ getEmail }}</span>
            </li>
            <li>
              <span class="cursorButton" @click="myinfoclick">내정보</span>
              <span>&nbsp;|&nbsp;</span>
              <span class="cursorButton" @click="pointclick">포인트</span>
            </li>
            <li>
              <icon size="xxsmall" uicon="146"/>
              <span id="myCardPoint">포인트 : {{ getPoint }}</span>
            </li>
            <li>
              <icon size="xxsmall" uicon="147"/>
              <span id="myCardPoint">수익금 : {{ getCoin }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="myCardMenu">
        <ul>
          <li>
            <Ubutton size="small" text="내 서재" state="in-deactive" @click.native="gosubscribe"/>
          </li>
          <!-- <li>
            <Ubutton size="small" text="도움말" state="in-deactive" @click.native="$router.push('join')"/>
          </li> -->
          <li>
            <Ubutton size="small" text="로그아웃" state="in-deactive" @click.native="logout"/>
          </li>
        </ul>
      </div>
    </div>
    <div id="alarmView" v-show="alarmView">
      <div class="alarmList">
        <div class="alarmItem cursorButton" v-for="(item, index) in alarmList" :key="index" @click="alarmclick(item)">
          <div class="alarmInfo">
            <Profile v-if="Alarm.isProfile(item)" class="img" size="small" :src="Alarm.getProfile(item)"/>
            <icon v-else size="profile" class="active" :uicon="Alarm.getProfile(item)"/>
            <span v-html="Alarm.getAlarmText(item)" />
          </div>
          <span class="description">{{ Alarm.getAlarmSubText(item) }}</span>
        </div>
      </div>
      <div>
        <span>확인하지 않은 {{ alarmCount }}개의 알림이 있습니다.</span>
      </div>
      <div>
        <Ubutton type="text" text="전체보기" state="active" @click="goAllPage()"/>
      </div>
    </div>
  </header>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import {Alarm} from '@/components/js/Utils'

export default {
  props: {
    searchInit: {
      type: String
    }
  },
  mounted () {
    console.log('mounted top', this.$route, this.isLogin)
    if (this.$route.params.text !== undefined) {
      this.search = this.$route.params.text
    }
    // this.search = (this.searchInit) ? this.searchInit : ''
  },
  data () {
    return {
      Alarm: Alarm,
      info: null,
      infoView: false,
      search: '',
      layer: false,
      userList: [],
      workList: [],
      bookList: [],
      alarmView: false,
      alarmCount: 0,
      alarmList: []
    }
  },
  name: 'TmekaTop',
  watch: {
    search (val) {
      console.log('activeElement', document.activeElement)
      if (val !== undefined && val !== '') {
        this.loadSearch()
      } else {
        this.userList = []
        this.workList = []
        this.bookList = []
      }
    },
    isLogin (val) {
      console.log('isLogin', val, this.info)
      if (val) {
        if (this.info === null) {
          switch (this.$store.getters.auth) {
            case 'admin':
            case 'drive':
              break
            default:
              if (this.$store.getters.profile === '') {
                this.$http.post('/api/user/myInfo').then((row) => {
                  console.log(row)
                  if (row.success) {
                    this.info = row
                    this.$store.commit('profile', this.info.Profile)
                    this.$store.commit('nic', this.info.Nic)
                    this.$store.commit('chargePoint', this.info.ChargePoint)
                    this.$store.commit('revenuePoint', this.info.RevenuePoint)
                  } else {
                    this.$store.dispatch('logOut')
                  }
                })
              }
              this.$store.dispatch('isalarm')
              this.timeInterval = setInterval(this.callalarm, 60000)
              break
          }
        }
      }
    },
    '$route': 'setSearch'
  },
  computed: {
    getNic () {
      return this.$store.getters.nic
    },
    getProfile () {
      console.log('getProfile', this.$store.getters.profile)
      console.log(typeof this.$store.getters.profile)
      return (this.info) ? this.$store.getters.profile : ''
    },
    getEmail () {
      return (this.info) ? this.info.Email : ''
    },
    getPoint () {
      return this.$store.getters.chargePoint
    },
    getCoin () {
      return this.$store.getters.revenuePoint
    }
  },
  components: {
    UInput
  },
  methods: {
    callalarm () {
      if (this.$store.getters.isalarm) {
        console.log('isalarm notcall true')
      } else {
        this.$store.dispatch('isalarm')
      }
    },
    setSearch (val) {
      console.log('this.$route.params.text', val)
      if (val.params.text !== undefined) {
        this.search = val.params.text
      }
      console.log(this.search, val.params.text)
    },
    myinfoclick (e) {
      if (this.$route.name !== 'profile') {
        this.$router.push({name: 'profile'})
      }
      this.infoView = false
    },
    accountclick (e) {
      this.$router.push({name: 'profile'})
      this.infoView = false
    },
    pointclick (e) {
      if (this.$route.name !== 'point-total') {
        this.$router.push({name: 'point-total'})
      }
      this.infoView = false
    },
    menuHandler (e) {
      console.log(e)
    },
    alertHandler (e) {
      console.log('submit', e)
    },
    calendarHandler (e) {
      console.log('calendarHandler', e)
    },
    profileOpen (e) {
      // console.log('profileOpen', e)
      if (this.infoView) {
        this.infoView = false
        this.$root.$el.removeEventListener('mouseup', this.mouseUp)
      } else {
        if (this.$store.getters.profile === '' || this.$store.getters.profile === null) {
          this.$http.post('/api/user/myInfo').then((row) => {
            console.log(row)
            if (row.success) {
              this.info = row
              this.$store.commit('profile', this.info.Profile)
              this.$store.commit('nic', this.info.Nic)
              this.$store.commit('chargePoint', this.info.ChargePoint)
              this.$store.commit('revenuePoint', this.info.RevenuePoint)
              this.infoView = true
              this.$root.$el.addEventListener('mouseup', this.mouseUp)
            } else {
            }
          })
        } else {
          this.infoView = true
          this.$root.$el.addEventListener('mouseup', this.mouseUp)
        }
      }
    },
    openAlarm () {
      if (this.alarmView) {
        this.alarmView = false
        this.$root.$el.removeEventListener('mouseup', this.mouseAlarmUp)
      } else {
        this.alarmView = true
        this.$http.post('/api/user/alarmTopList').then((row) => {
          console.log('alarmTopList', row)
          if (row.success) {
            this.alarmList = row.data
            this.alarmCount = row.readcount
            this.$root.$el.addEventListener('mouseup', this.mouseAlarmUp)
          } else {
          }
        })
      }
    },
    alarmclick (item) {
      this.$http.post('/api/user/readAlarm', {id: item._id}).then((row) => {
        console.log('readAlarm', row)
        if (row.success) {
          switch (item.type) {
            case Alarm.COMMENT :
            case Alarm.COMMENT_RE :
            case Alarm.LIKE :
            case Alarm.NEWPOST :
              this.$router.push({name: 'post', params: {type: 'info', post: item.post._id}})
              break
            case Alarm.POINT_SUPPORT :
            case Alarm.POINT_BUY :
              this.$router.push({name: 'point-total'})
              break
            case Alarm.POINT_WITHDRAWAL_CANCEL :
            case Alarm.POINT_CHANGE_CANCEL :
            case Alarm.POINT_CHANGE_SUBMIT :
              this.$router.push({name: 'point-withdrawal'})
              break
            case Alarm.SUBSCRIBE :
              break
            case Alarm.NOTICE :
              var link = item.noticelink.indexOf('http') === -1 ? 'http://' + item.noticelink : item.noticelink
              window.location.href = link
              break
          }
          this.$store.dispatch('isalarm')
          this.alarmView = false
        } else {
        }
      })
    },
    logout () {
      this.$store.dispatch('logOut')
      this.info = null
      this.infoView = false
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
      console.log(this.$route)
      if (this.$route.name !== 'main') {
        this.$router.push({name: 'main'})
      }
    },
    mouseAlarmUp (e) {
      if (!this.isTarget(e, this.$el.querySelector('#alarmView')) && !this.isTarget(e, this.$el.querySelector('.alarm'))) {
        console.log('mouseUp')
        this.alarmView = false
        this.$root.$el.removeEventListener('mouseup', this.mouseAlarmUp)
      }
    },
    mouseUp (e) {
      if (!this.isTarget(e, this.$el.querySelector('#myCard')) && !this.isTarget(e, this.$el.querySelector('.profileArea'))) {
        console.log('mouseUp')
        this.infoView = false
        this.$root.$el.removeEventListener('mouseup', this.mouseUp)
      }
    },
    gosubscribe (e) {
      this.$router.push({name: 'worklist', params: {user: this.info.id}})
      this.infoView = false
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    },
    loadSearch () {
      if (document.activeElement === document.querySelector('#search input')) {
        this.$http.post('/api/search/search', {search: this.search, limit: 3, page: 0}).then((e) => {
          console.log(e)
          if (e.success) {
            this.userList = e.user
            this.workList = e.work
            this.bookList = e.book
            this.layer = this.userList.length > 0 || this.workList.length > 0 || this.bookList.length > 0
            if (this.layer) {
              this.$root.$el.addEventListener('mouseup', this.mouseSearchUp)
            }
          } else {
          }
        })
      }
    },
    searchFocus () {
      console.log(this.search)
      console.log('activeElement', document.activeElement)
      if (this.search !== '') {
        this.loadSearch()
      }
    },
    mouseSearchUp (e) {
      console.log('mouseSearchUp')
      console.log(this.isTarget(e, document.querySelector('input')))
      if (this.isTarget(e, document.querySelector('input'))) {
      } else {
        if (!this.isTarget(e, document.querySelector('#searchLayer'))) {
          this.layer = false
          this.$root.$el.removeEventListener('mouseup', this.mouseSearchUp)
        }
      }
    },
    goLink (link, param) {
      if (this.$route.name !== link) {
        this.$router.push({name: link, params: param})
      }
    },
    goAllPage () {
      this.$router.push({name: 'alarm'})
      this.alarmView = false
    }
  }
}
</script>

<style scoped>
header {
  width: 100%;
  height: 55px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
  z-index: 10;
  color: var(--text-base);
  padding-left: 40px;
}
header .searchInputBox {
  margin-left: 30px;
  width: 250px;
  z-index: 3;
}
.logoBtn {
  margin-left: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 3;
  color: var(--text-title);
}
.logo + span {
  margin-left: 2px;
  font-size: 25px;
  font-weight: bold;
}
.logoBtn + span {
  margin-left: 10px;
  margin-right: 10px;
}
.input {
  position: relative;
  margin-left: 40px;
  min-width: 100px;
  max-width: 450px;
  height: 30px;
  flex: 1;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid var(--line-guide);
}
.topNav {
  /* position: absolute; */
  /* top: 0;
  left:0px; */
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 55px;
  align-items: center;
  z-index: 2;
}
.topNav img {
  width: 20px;
  height: 20px;
}
.topNavBtn {
  margin-left: 40px;
}
.topRightNav{
  /* position: absolute; */
  /* margin: 0;
  right: 80px; */
  display: flex;
  margin-left: auto;
  margin-right: 80px;
  font-weight: bold;
}
.topRightNav .profileImg {
  border: 1px solid var(--line-guide);
}
h1 {
  font-size: 4em;
}
.topRightNav li {
  min-width: 45px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.topRightNav a {
}
.topRightNav .alarm {
  position: relative;
}
.topRightNav .alarm .isnew {
  position: absolute;
  width: 5px;
  height: 5px;
  top: 3px;
  right: 0px;
  display: block;
  background-color: var(--active);
  border-radius: 50%;
}
#myCard {
  background-color: var(--bg-white);
  position: absolute;
  border: 1px solid var(--line-base);
  top: 60px;
  right: 75px;
  flex-direction: column;
  box-shadow: 2px 3px 4px 0px rgba(200,200,200,0.5);
  z-index: 100;
}
#myCard > div {
  display: flex;
  flex-direction: row;
}
#myCard ul {
  list-style: none;
  display: flex;
}
#myCard::after {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 0 10px 16px 12px;
  border-color: var(--bg-white) transparent;
  display: block;
  width: 0;
  z-index: 102;
  top: -14px;
  right: 8px;
}
#myCard::before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 0 10px 16px 12px;
  border-color: var(--line-base) transparent;
  display: block;
  width: 0;
  z-index: 101;
  top: -16px;
  right: 8px;
}
.myCardInfo {
  padding: 2px 2px 2px 2px;
  box-sizing: border-box;
  height: 130px;
}
.myCardInfo > div:last-child {
  height: 100%;
  width: calc(100% - 110px);
  padding: 10px 10px 10px 10px;
}
.myCardInfoList {
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
.myCardInfoList li {
  height: calc(100% / 4);
  width: 138px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
}
#myCardNic {
  font-weight: bold;
  color: var(--text-title);
}
#myCardPoint, .myCardPoint{
  margin-left: 5px;
  display: inline-flex;
}
.myCardUserImg {
  height: 100%;
  width: 110px;
  padding-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.myCardUserImg > a {
  position: relative;
}
.myCardMenu ul {
  padding: 0px 1px 1px 1px;
  width: 100%;
  height: 31px;
  flex-direction: row;
}
.myCardMenu ul li {
  display: flex;
  flex: 1;
  /* width: calc(100% / 3); */
  height: 100%;
}
.myCardMenu ul li button {
  display: flex;
  flex: 1;
}
#searchLayer {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--line-guide);
  background-color: var(--bg-white);
  width: 450px;
  left: -1px;
  top: 28px;
  line-height: 35px;
}
#searchLayer > div {
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
#searchLayer > div:nth-last-child(1n+2) {
  border-bottom: 1px solid var(--line-guide);
}
#searchLayer > div > span {
  color: var(--text-title);
}
#searchLayer > div > li {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 5px;
  cursor: pointer;
}
#searchLayer > div span + span {
  margin-left: 5px;
}
#searchLayer .cover {
  height: 60px;
  width: 40px;
  margin-right: 5px;
}
#searchLayer .cover.not {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--line-guide);
  color: var(--text-guide);
}
#searchLayer .cover img {
  width: 100%;
  height: 100%;
}
#searchLayer .searchbook > li > div {
  display: flex;
  flex-direction: column;
  line-height: 20px;
}
#myCardEmail > span {
  display: block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#alarmView {
  background-color: var(--bg-white);
  position: absolute;
  border: 1px solid var(--line-base);
  top: 60px;
  right: 75px;
  width: var(--bookW);
  flex-direction: column;
  box-shadow: 2px 3px 4px 0px rgba(200,200,200,0.5);
  z-index: 100;
}
#alarmView > div:last-child {
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
}
#alarmView > div:last-child > span {
  flex: 1;
}
#alarmView .alarmList {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.alarmList .alarmItem {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 5px;
}
.alarmItem .alarmInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.alarmItem .alarmInfo span + span {
  margin-left: 5px;
  color: var(--text-title);
}
.alarmItem .description {
  margin-left: 35px;
  margin-top: 5px;
  color: var(--text-guide);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Top.vue